import React, { Component } from "react";

import { HomeSlider, HomeTitle, Img } from "../../Components/UI/UI";

import { getWeather } from "../../Utility/Utility";

import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

import "./CoronaVirus.css";

class CoronaVirus extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    getWeather((Weather) => {
      //console.log("Weather", Weather);
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    return (
      <div className="page align-left page-Corona-virus">
        <Menu />
        <HomeSlider
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />

        <div className="container">
          <p>
            During these challenging times, we in Israel stand together with
            you, the UK people, offering our prayers and support, united in the
            hope for a brighter, better tomorrow.
          </p>

          {/* <h1>ISRAEL TRAVEL ALERTS & SAFETY INFORMATION</h1>*/}

          <h2 className="ac-pink">
            LATEST INFORMATION FOR TOURISTS TO ISRAEL ON THE CORONAVIRUS
            (COVID-19):
          </h2>

          {/* <h2 className="ac-pink">Israel Has Announced Further Relief Measures</h2> 


              <p>
              As of the 1st of June, Israel's Ministry of Health has announced another series of relief measures, among them, the opening of restaurants, tourist attractions and hotels.
              </p>

              <p>The beaches were opened on May 20th.</p>

              <p>As of May 27th, 2020, restaurants, bars, pubs, and clubs are allowed to open, subject to some restrictions. Leisure and tourist attractions such as hotels, museums and swimming pools are also allowed to open, subject to some restrictions.</p> 

              <p>The ministry of health has also agreed to increase bus and taxi passenger capacity, as well as to resume trains activity, from the 8th of June.</p> 

              <p>Entertainment and leisure activities will resume on June 14th, including event venues and gardens, concerts, theatres, cinema, art and cultural events, subject to some restrictions.</p> 

              <p>In the tourism sector, several countries have announced opening their borders to Israeli citizens:  Greece, Austria, Montenegro, Georgia and now Cyprus (starting June 9th).</p>  

              <p>International airlines such as Delta Airlines, British Airways, Air Canada, Wizz Air, Ryanair, Lufthansa, Turkish Airlines, Alitalia, Ukrainian International and more have announced their intention of resuming commercial flights to and from Israel this summer.</p> */}

          <h2 className="ac-pink ac-margin-top-1 ac-bigger">
            Tourists looking
            <br className="show-on-mobile" /> to travel to Israel:
          </h2>

          <p className="ac-align-left-15">
            <strong>At the moment, and until further notice,</strong> entry to
            Israel will be refused to non-citizens or non-residents of Israel
            arriving from anywhere in the world. In exceptional cases, one may
            apply for approval of the Foreign Ministry subject to proof of the
            ability to remain in self-isolation for 14 days.
          </p>

          <h2 className="ac-pink ac-bigger">
            {" "}
            General guidelines for all
            <br className="show-on-mobile" /> those staying in Israel:{" "}
          </h2>

          <ul>
            <li>
              For the latest information on coronavirus cases in Israel, please
              refer to the Department of Health's{" "}
              <a
                href="https://govextra.gov.il/ministry-of-health/corona/corona-virus-en/"
                target="_blank"
              >
                website
              </a>
              .
            </li>
            <li>
              The Israeli Government is monitoring the outbreak closely and has
              implemented temporary measures including border restrictions for
              travellers from around the world.
            </li>
            <li>
              People showing symptoms are not permitted to accompany patients or
              visit institutions for seniors.
            </li>
          </ul>

          <h2 className="ac-pink">Important! </h2>

          <ul>
            <li>
              If you’ve been required to enter self-isolation,{" "}
              <strong>you must report it to the Ministry of Health: </strong>
              <a
                href="https://govforms.gov.il/mw/forms/HouseIsolation%40health.gov.il?displang=en"
                target="_blank"
              >
                <strong>www.govforms.gov.il/</strong>
              </a>
            </li>
          </ul>

          <ul>
            <li>
              If you develop a fever of 100.4F (38C) or higher, a cough, trouble
              breathing, or other respiratory symptoms,{" "}
              <strong className="ac-pink">
                you must immediately enter self-isolation and call the 101 MDA
                Emergency Services Hotline for medical advice.
              </strong>
            </li>
            <li>
              <strong className="ac-pink">
                It is absolutely forbidden to enter clinics or hospitals if you
                are showing any of the above symptoms!
              </strong>
            </li>
          </ul>

          <h2 className="ac-pink">Frequently Asked Questions</h2>

          <ol start="1" className="ac-padding-start">
            <li>
              <strong className="ac-pink">
                I am a tourist in Israel and I am concerned that I may have
                COVID-19, where should I go?
              </strong>
            </li>
          </ol>

          <p className="ac-align-left-15">
            If you have a fever of 100.4F (38C) or higher, cough, trouble
            breathing, or other respiratory symptoms, you must immediately enter
            self-isolation and call the 101 MDA Emergency Services Hotline for
            medical advice.
            <strong className="ac-pink">
              Do not go to an HMO clinic or emergency ward.
            </strong>
          </p>

          <ol start="2" className="ac-padding-start">
            <li>
              <strong className="ac-pink">
                When will Israel be open to incoming visitors again?
              </strong>
            </li>
          </ol>

          <p className="ac-align-left-15">
            At this moment there is not a known date in which Israel will be
            open to incoming visitors.
          </p>

          <Img desktopImg={"infection.jpg"} />
        </div>

        <Footer />
      </div>
    );
  }
}

export default CoronaVirus;



// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirusHU.js